module.exports = __webpack_public_path__ + "static/media/csu_logo.7f04b1c1.svg";